<template>
  <div class="month-group">
    <el-row :gutter="40">
      <el-col :span="12">
        <div class="month-group-item transition-label">
          <el-button
            class="egl-btn-yellow month-group-btn"
            @click="getCurMonth(-1, 'startMonth')"
          >
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-date-picker
            class="month-group-input"
            type="month"
            v-model="filter.startMonth"
            :clearable="false"
            @change="getCurMonth(0, 'startMonth')"
            value-format="timestamp"
            format="yyyy-MM"
            :picker-options="startTimePickerOptions"
            :disabled="disabled"
          >
          </el-date-picker>
          <el-button
            class="egl-btn-yellow month-group-btn"
            @click="getCurMonth(1, 'startMonth')"
          >
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="month-group-item">
          <el-button
            class="egl-btn-yellow month-group-btn"
            @click="getCurMonth(-1, 'endMonth')"
          >
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-date-picker
            class="month-group-input"
            type="month"
            v-model="filter.endMonth"
            :clearable="false"
            @change="getCurMonth(0, 'endMonth')"
            value-format="timestamp"
            format="yyyy-MM"
            :picker-options="endTimePickerOptions"
            :disabled="disabled"
          >
          </el-date-picker>
          <el-button
            class="egl-btn-yellow month-group-btn"
            @click="getCurMonth(1, 'endMonth')"
          >
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "MonthPickerGroup",
  data() {
    return {
      filter: {
        startMonth: 0,
        endMonth: 0
      },
      endTimePickerOptions: {
        disabledDate: this.endTimeDisableMonth
      },
      startTimePickerOptions: {
        disabledDate: this.startTimeDisableMonth
      },
    };
  },
  methods: {
    endTimeDisableMonth(time) {
      const maxMonth = this.max ? this.max : this.$moment().startOf("month").valueOf();

      return (
        time.getTime() > maxMonth ||
        time.getTime() < this.$moment(this.filter.startMonth).startOf("month").valueOf()
      );
    },
    startTimeDisableMonth(time) {
      return time.getTime() > this.$moment(this.filter.endMonth).startOf("month").valueOf();
    },
    getCurMonth(num = 0, keyName) {
      let newFilter = { ...this.filter };
      const currentMonth = this.$moment().startOf("month").valueOf();
      const maxMonth = this.max ? this.max : currentMonth;
      newFilter[keyName] = num === 0 ? this.$moment(newFilter[keyName]).startOf("month").valueOf() : this.$moment(newFilter[keyName]).startOf("month").subtract(-(num), "months").valueOf();

      newFilter.endMonth = newFilter.endMonth < newFilter.startMonth ? newFilter.startMonth : newFilter.endMonth;
      newFilter.endMonth = newFilter.endMonth > maxMonth ? maxMonth : newFilter.endMonth;
      newFilter.startMonth = newFilter.startMonth > newFilter.endMonth ? newFilter.endMonth : newFilter.startMonth;

      this.$emit("setFatherDate", {
        startMonth: newFilter.startMonth,
        endMonth: newFilter.endMonth
      });
    }
  },
  mounted() {
    let curDay2 = this.$moment().startOf("month").valueOf();
    let startMonth = "";
    let endMonth = "";

    startMonth = this.start === 0 ? curDay2 : this.start;
    endMonth = this.end === 0 ? curDay2 : this.end;

    this.filter = {
      startMonth: startMonth,
      endMonth: endMonth
    };
  },
  props: {
    start: {
      type: Number,
      default: () => 0
    },
    end: {
      type: Number,
      default: () => 0
    },
    max: {
      type: Number,
      // default: Infinity,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isExp: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    end() {
      this.filter = {
        startMonth: this.$moment(this.start).startOf("month").valueOf(),
        endMonth: this.$moment(this.end).startOf("month").valueOf()
      };
    },
    start() {
      this.filter = {
        startMonth: this.$moment(this.start).startOf("month").valueOf(),
        endMonth: this.$moment(this.end).startOf("month").valueOf()
      };
    }
  }
};
</script>

<style lang="less" scope>
.month-group {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 620px;
  vertical-align: middle;

  & + button {
    margin-left: 10px;
    vertical-align: middle;
  }

  .month-group-item {
    display: inline-flex;
    width: 100%;
    max-width: 294px;

    .month-group-btn {
      width: 40px;
      height: 40px;
      padding: 0;
    }

    .month-group-input {
      flex: 1;
      padding: 0 10px;

      .el-input__prefix {
        left: auto;
        right: 20px;
      }

      .el-input__inner {
        padding-left: 15px;
        padding-right: 40px;
      }
    }
  }

  .month-group-connect {
    width: 20px;
    height: 100%;
    line-height: 40px;
    margin-left: -10px;
    position: absolute;
    top: 0;
    left: 50%;
    text-align: center;
    font-size: 1.6rem;
  }

  .transition-label {
    position: relative;

    &::after {
      content: "~";
      display: block;
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 1.4rem;
      top: 0;
      right: -25px;
    }
  }

}
</style>
